import axios from './BaseService';

const ALERTS_URL = `${process.env.REACT_APP_API_URL}/alerts`;

export async function getConfig() {
    const response = await axios.get(`${ALERTS_URL}/config`);
    return response.data;
}

export async function updateConfig(config) {
    const response = await axios.put(`${ALERTS_URL}/config`, config);
    return response.data;
}

export async function testNow() {
    const response = await axios.post(`${ALERTS_URL}/test`, {});
    return response.data;
}
